import React, {useEffect, useState} from "react";
import {getImageFromFilesbyKey} from "../../../_metronic/_helpers";
import {useHistory} from "react-router";

//components:
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import SwiperCore, {A11y, Autoplay, Navigation, Pagination, Scrollbar} from "swiper";
import {SkipNext, SkipPrevious} from "@material-ui/icons";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

const TextualResults = (props) => {
    const {matches, onMatchClick, query, id} = props;

    const [page, setPage] = useState(0);
    const pageSize = 10;

    return <>
        {/*Mostrando de {page * pageSize} a {page * pageSize + pageSize}*/}
        <div className="searchResultSlide_body">
            <div className="searchResultSlide_content custom-scroll-area">
                {matches.slice(page * pageSize, page * pageSize + pageSize).map((content, i) => (
                    <div
                        className="text-muted font-weight-bold font-size-sm d-block p-2 bg-hover-light rounded"
                        onClick={() =>
                            onMatchClick({
                                id,
                                text: query,
                                time: content?.start,
                            })
                        }
                        key={i}
                    >
                    <span
                        className="font-weight-bold font-size-sm text-primary text-hover-info cursor-pointer">
                {content?.start?.replace(
                    /\.\d+/,
                    "",
                ) || ""}
                        <span className="px-1">·</span>
                    </span>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: content.text,
                            }}
                        />
                    </div>
                ))
                }
            </div>
        </div>
        <div className={"d-flex justify-content-between"}>
            <button className={"btn btn-light"} onClick={() => {
                setPage(page - 1);
            }}
                    disabled={page === 0}>
                <SkipPrevious />
            </button>
            <button className={"btn btn-light"} onClick={() => {
                setPage(page + 1);
            }}
                    disabled={Math.ceil(matches.length / pageSize) <= (page + 1)}>
                <SkipNext />
            </button>
        </div>
    </>;
};

export const SearchResultsCarousel = (props) => {
    const {
        titleClassName = "",
        htmlTagTitle = "",
        spaceBetween = 10,
        onMatchClick,
        videos = [],
        errorMessage = "",
        query = "",
    } = props;
    const history = useHistory();

    const handleCardClick = id => {
        history.push(`/media/${id}`);
    };
    return (
        <>
            {htmlTagTitle ? (
                <h3
                    className={`${titleClassName}`}
                    dangerouslySetInnerHTML={{
                        __html: htmlTagTitle,
                    }}
                />
            ) : null}
            {errorMessage ? (
                <div className="alert alert-light font-weight-bold w-fit-content d-flex align-items-center">
                    <WarningRoundedIcon color="inherit" className="mr-5" /> {errorMessage}
                </div>
            ) : null}
            <div className="row">
                {videos.length ? videos.map(({id, title, files, matches}) =>
                        (
                            <div key={id} className="col-md-6 col-lg-4 col-xl-3 col-xxl-3 movieShowcase__container--movie__netflix">
                                <div className="searchResultSlide card card-custom card-stretch link-card shadow">
                                    <div className="flex cursor-pointer" onClick={() => handleCardClick(id)}>
                                        <div
                                            className="searchResultSlide_image w-100 card-img-top bg_image_cover"
                                            style={{
                                                backgroundImage: `url(${getImageFromFilesbyKey(
                                                    files,
                                                    id,
                                                    "imgLandscape",
                                                    // !! type_id !!
                                                    1
                                                )})`,
                                            }}
                                        />
                                        <div className="card-header border-0">
                                            <h5 className="searchResultSlide_title font-weight-bolder text-dark-75 text-hover-primary m-0 elipsis_3lines">
                                                {title || ""}
                                            </h5>
                                        </div>
                                    </div>
                                    {/* body: */}
                                    <TextualResults id={id} onMatchClick={onMatchClick} matches={matches} query={query} />
                                </div>
                            </div>
                        ))
                    : null}
            </div>
        </>
    );
};
